import React from "react";
import "../styles/About.css";
import Contact from "../components/Contact";
import PDF from "../Documents/resume.pdf";

function About() {
  return (
    <div className={`about__wrapper`} id="about">
      {/* <div className="about__profilePic">
        <img src="./icons/profilePic.png" className="avatar" alt="profile" />
      </div> */}

      <div className="about__story">
        <h2>Types of jobs you should hire me for:</h2>
        <p>
          I am a Full Stack Developer with experience in MERN, PERN, and NRN stacks and writing node servers to run custom automation scripts and manage an API. I have experience with a variety of front end
          frameworks and libraries such as React, Angular, and Vue. This is why I would be perfect for you to consider me for the following positions:
        </p>

        <p>
          <ul>
            <li>Full Stack Developer</li>
            <li>Software Engineer</li>
            <li>Software Developer</li>
            <li>Frontend Developer</li>
            <li>UI/UX Developer</li>
            <li>Web Developer</li>
            <li>React Developer</li>
            <li>React Native Developer</li>
            <li>Backend Developer</li>
          </ul>
        </p>

        <div className="about__button">
          <a href={PDF}>
            View Resume
          </a>
        </div>
      </div>

      <Contact />
    </div>
  );
}

export default About;
